// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { groups } from '../../../../APIRoutes'
import axiosRequest from '../../../../APIRoutes/axiosCall'
import { displaySuccessToast } from '../../../../utility/helper'
export const getAdminGroups = createAsyncThunk('adminGroups/getAdminGroups', async () => {
  const response = await axiosRequest.get(groups.ADMIN_GROUPS)
  return { data: response?.data?.data }
})

export const setGroups = createAsyncThunk('adminGroups/setGroups', async (data) => {
  return { data }
})

export const addGroup = createAsyncThunk('adminGroups/addGroup', async (data, { dispatch }) => {
  const response = await axiosRequest.post(groups.ADMIN_ADD_GROUP, data)
  dispatch(getAdminGroups())
  return { status: response?.data?.status }
})

export const updateGroup = createAsyncThunk('adminGroups/updateGroup', async (data, { dispatch }) => {
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  }
  const response = await axiosRequest.post(groups.ADMIN_EDIT_GROUP, data, config)
  dispatch(getAdminGroups())
  return { status: response?.data?.status }
})

export const deleteGroup = createAsyncThunk('adminGroups/deleteGroup', async (id) => {
  const response = await axiosRequest.post(groups.ADMIN_DELETE_GROUP, { id })
  return { id, status: response.data?.status }
})
// POSTS
export const getGroupPosts = createAsyncThunk('adminGroups/getGroupPosts', async (id) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_POSTS, { group_id: id })
  return { data: response?.data?.data }
})

export const setGroupPosts = createAsyncThunk('adminGroups/setGroupPosts', async (data) => {
  return { data }
})

export const createGroupPost = createAsyncThunk('adminGroups/createGroupPost', async ({ data, group_id }, { dispatch }) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_CREATE_POST, data)
  dispatch(getGroupPosts(group_id))
  return { status: response?.data?.status }
})

export const editGroupPost = createAsyncThunk('adminGroups/editGroupPost', async ({ data, group_id }, { dispatch }) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_EDIT_POST, data)
  dispatch(getGroupPosts(group_id))
  return { status: response?.data?.status }
})

export const deleteGroupPost = createAsyncThunk('adminGroups/deleteGroupPost', async (id) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_DELETE_POST, { id })
  return { id, status: response.data?.status }
})

export const getGroupPostComments = createAsyncThunk('adminGroups/getGroupPostComments', async (id) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_POST_COMMENTS, { post_id: id })
  return { data: response?.data?.data }
})

export const setGroupPostComments = createAsyncThunk('adminGroups/setGroupPostComments', async (data) => {
  return { data }
})

export const deleteGroupPostComment = createAsyncThunk('adminGroups/deleteGroupPostComment', async (id) => {
  const response = await axiosRequest.post(groups.ADMIN_GROUP_POST_DELETE_COMMENT, { id })
  console.log("delete comments response", response.data)
  return { id, status: response?.data?.status }
})

export const adminGroupsSlice = createSlice({
  name: 'adminGroups',
  initialState: {
    data: [],
    loading: true,
    groupPosts: [],
    postComments: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAdminGroups.fulfilled, (state, { payload }) => {
        state.data = payload?.data ?? []
        state.loading = false
      })
      .addCase(getAdminGroups.pending, (state) => {
        console.log("LOADING...")
        state.loading = true
      })
      .addCase(getAdminGroups.rejected, (state) => {
        console.log("REJECTED...")
        state.loading = false
      })
      .addCase(setGroups.fulfilled, (state, { payload }) => {
        state.data = payload?.data ?? []
      })
      .addCase(addGroup.fulfilled, (state, { payload }) => {
        displaySuccessToast('Group has been Added Successfully')
        console.log(`CREATED GROUP ${payload?.status}`)
        state.status = payload?.status ?? []
      })
      .addCase(updateGroup.fulfilled, (state, { payload }) => {
        displaySuccessToast('Group has been Updated Successfully')
        console.log(`UPDATED GROUP ${payload?.status}`)
      })
      .addCase(deleteGroup.fulfilled, (state, { payload }) => {
        console.log(`DELETED GROUP ${payload.id}`)
      })

      .addCase(getGroupPosts.fulfilled, (state, { payload }) => {
        state.groupPosts = payload?.data ?? []
      })
      .addCase(setGroupPosts.fulfilled, (state, { payload }) => {
        state.groupPosts = payload?.data ?? []
      })
      .addCase(createGroupPost.fulfilled, (state, { payload }) => {
        displaySuccessToast('Group Post has been Created Successfully')
        console.log(`CREATED GROUP POST ${payload?.status}`)
        state.status = payload?.status ?? []
      })
      .addCase(editGroupPost.fulfilled, (state, { payload }) => {
        displaySuccessToast('Group post has been Edited Successfully')
        console.log(`EDITED GROUP POST ${payload?.status}`)
        state.status = payload?.status ?? []
      })
      .addCase(deleteGroupPost.fulfilled, (state, { payload }) => {
        console.log(`DELETED GROUP POST ${payload?.id}`)
        state.status = payload?.status ?? []
      })

      .addCase(getGroupPostComments.fulfilled, (state, { payload }) => {
        state.postComments = payload?.data ?? []
      })
      .addCase(setGroupPostComments.fulfilled, (state, { payload }) => {
        state.postComments = payload?.data ?? []
      })
      .addCase(deleteGroupPostComment.fulfilled, (state, { payload }) => {
        console.log(`DELETED GROUP COMMENT ${payload?.id}`)
        state.status = payload?.status ?? []
      })
  }
})

export default adminGroupsSlice.reducer
